import USER_TYPES from '@/constants/authorization/user-types'

export default [
  {
    path: '',
    name: 'admin:customers',
    meta: { userTypes: [USER_TYPES.BRANCH_ADMIN] },
    component: () => import(/* webpackChunkName: "clients" */ '@/views/admin/marketing/clients/ClientsTable.vue'),
  },
  {
    path: 'items-insight',
    name: 'admin:customers:items-insight',
    meta: { userTypes: [USER_TYPES.BRANCH_ADMIN] },
    component: () => import(/* webpackChunkName: "clients" */ '@/views/admin/marketing/clients/ItemsInsight.vue'),
  },
  {
    path: 'statistics',
    name: 'admin:customers:statistics',
    meta: { userTypes: [USER_TYPES.BRANCH_ADMIN] },
    component: () => import(/* webpackChunkName: "clients" */ '@/views/admin/marketing/clients/CustomerStatistics.vue'),
  },
  {
    path: 'profile/:id',
    name: 'admin:customers:profile',
    meta: { userTypes: [USER_TYPES.BRANCH_ADMIN] },
    component: () => import(/* webpackChunkName: "clients" */ '@/views/admin/marketing/clients/CustomerDetails.vue'),
  },
  {
    path: 'edit/:id?',
    alias: 'add',
    name: 'admin:customers:form',
    meta: { userTypes: [USER_TYPES.OWNER] },
    component: () => import(/* webpackChunkName: "surveys" */ '@/views/admin/marketing/clients/components/forms/CustomerForm.vue'),
  },
]
